import React from 'react'
import BilGoogle from '@meronex/icons/bi/BilGoogle'
import { GoogleButton } from './styles'

import { useLanguage, FirebaseGoogleLoginButton as GoogleLoginController } from '~components'

const GoogleLoginButtonUI = (props) => {
  const [, t] = useLanguage()
  const { signInWithGoogle } = props

  return (
    <GoogleButton
      initialIcon
      color='secondary'
      onClick={signInWithGoogle}
    >
      <BilGoogle />
      <div>{t('GOOGLE', 'Google')}</div>
    </GoogleButton>
  )
}

export const GoogleLoginButton = (props) => {
  const googleLoginProps = {
    ...props,
    UIComponent: GoogleLoginButtonUI
  }
  return <GoogleLoginController {...googleLoginProps} />
}
